export default "assets/images/placement-icon-90f10ed6.svg";